<template>
  <div>
    <v-autocomplete
      id="member-select"
      v-model="filter.membroLocal"
      item-text="nome"
      item-name="membroId"
      :items="members"
      label="Membro"
      placeholder="Selecione um Membro Existente"
      v-on:change="$emit('onChange', filter.membroLocal)"
      :disabled="disabled"
      :return-object="true"
      clearable
    >
      <template slot="no-data"> Nenhum Grupo retornado </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { memberAPI } from "../MemberAPI";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppMemberCombobox",
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false },
  },
  mounted() {
    this.loadMembers();
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadMembers() {
      this.setLoading(true);

      if (
        this.isFullAdmin ||
        (this.config.verTodosMembrosMunicipio &&
          this.groupsConfig.verTodosMembrosMunicipio)
      ) {
        memberAPI
          .list()
          .then((resp) => {
            this.members = resp.data;
            this.setLoading(false);
          })
          .catch(this.setLoading(false));
      } else {
        memberAPI
          .getMembersByCity(this.filter.municipioId)
          .then((resp) => {
            this.members = resp.data;
            this.setLoading(false);
          })
          .catch(this.setLoading(false));
      }
    },
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
  },
  data() {
    return {
      members: [],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
};
</script>
